import { connect } from 'react-redux';
import ExcludeUnknownUrls from './ExcludeUnknownUrls';

const mapStateToProps = (state: any) => ({
  globalTrackerSettings: state.trackerSettings.global.settings,
  appTrackerSettings: state.trackerSettings.app.settings,
});

export default connect(mapStateToProps, null)(ExcludeUnknownUrls);
